import { DateTime } from "luxon";

export const MasterCampaignRunStatusEnum = {
  active: "started" as const,
  scheduled: "scheduled" as const,
  completed: "completed" as const,
};

export type MasterCampaignRunStatusEnum =
  (typeof MasterCampaignRunStatusEnum)[keyof typeof MasterCampaignRunStatusEnum];

export function getCampaignRunStatus(
  { start_at, end_at }: { start_at: string; end_at: string },
  now: number = Date.now(),
): MasterCampaignRunStatusEnum {
  const start = DateTime.fromISO(start_at).toMillis();
  const end = DateTime.fromISO(end_at).toMillis();
  if (now < start) {
    return MasterCampaignRunStatusEnum.scheduled;
  }
  if (now > end) {
    return MasterCampaignRunStatusEnum.completed;
  }
  return MasterCampaignRunStatusEnum.active;
}
